import React, { useState } from "react";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Menu, Space } from "antd";
import ModalConfirmLogout from "../../../components/ModalConfirmLogout";

const HeaderAdmin = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  const menu = (
    <Menu
      items={[
        {
          key: "logout",
          label: <span onClick={() => setIsShowLogout(true)}>Đăng xuất</span>,
          icon: <LogoutOutlined />,
        },
      ]}
    />
  );
  return (
    <div className="flex justify-end p-3 border-b-2">
      <Space direction="vertical" size={16}>
        <Space wrap size={16}>
          <Dropdown overlay={menu} trigger={["hover"]}>
            <Avatar
              size="large"
              icon={<UserOutlined />}
              style={{ cursor: "pointer" }}
            />
          </Dropdown>
        </Space>
      </Space>
      
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
};

export default HeaderAdmin;
